import React from "react";
import LaboratorySuiteSearcher from "./LaboratorySuiteSearcher";
import NewQuoteGroup from "./NewQuoteGroup";
import Button from "../Button";
import QuotableSorter from "./QuotableSorter";
import { fetchJson } from "../../lib/Fetching";
import styled from "styled-components";

const Link = styled.span`
  color: #88e;
  font-size: 93%;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export default class QuoteIndex extends React.Component {
  state = {
    quotables: [],
    isSorting: false,
    addingLaboratorySuite: false,
    addingNewGroup: false,
    isReordering: false,
    loading: true,
    last_matrix_id: null
  };

  componentDidMount() {
    this.refresh();
  }

  savePositions = () => {
    this.sorter.save(() => {
      this.setState({ isReordering: false });
      this.refresh();
    });
  };

  selectAdditionalGroups = conditionFunction => {
    const { quotables } = this.state;
    const { visible_quote_group_ids, selectQuoteGroups } = this.props;
    selectQuoteGroups(
      quotables
        .filter(
          q => visible_quote_group_ids.includes(q.quote_group_id) || conditionFunction(q)
        )
        .map(q => q.quote_group_id)
    );
  };

  selectByMatrix = matrix_id => {
    this.selectAdditionalGroups(quotable => quotable.matrix_id == matrix_id);
  };

  selectAll = () => {
    this.selectAdditionalGroups(_ => true);
  };

  onGroupsAdded = (ids, matrixOption) => {
    this.setState({ lastMatrixOption: matrixOption });
    this.refresh().then(() => {
      this.selectAdditionalGroups(quotable =>
        [].concat(ids).includes(quotable.quote_group_id)
      );
    });
  };

  refresh = () => {
    const { attempt_id } = this.props;
    this.setState({ loading: true });
    return fetchJson("/attempts/root_quote_groups.json", { id: attempt_id }).then(
      quotables => {
        this.setState(
          {
            quotables,
            loading: false,
            isReordering: false,
            addingLaboratorySuite: false,
            addingNewGroup: false
          },
          this.updateGroupOrder
        );
      }
    );
  };

  toggleAddingLaboratorySuites = () => {
    this.setState(state => ({
      isReordering: false,
      addingLaboratorySuite: !state.addingLaboratorySuite,
      addingNewGroup: false
    }));
  };

  toggleAddingNewGroup = () => {
    this.setState(state => ({
      isReordering: false,
      addingNewGroup: !state.addingNewGroup,
      addingLaboratorySuite: false
    }));
  };

  toggleReordering = () => {
    this.setState({
      isReordering: !this.state.isReordering,
      addingLaboratorySuite: false,
      addingNewGroup: false
    });
  };

  willUnSelectAll() {
    const { visible_quote_group_ids } = this.props;
    const { quotables } = this.state;
    return visible_quote_group_ids.length >= quotables.length / 2;
  }

  toggleSelectAll = () => {
    const { selectQuoteGroups } = this.props;
    if (this.willUnSelectAll()) {
      selectQuoteGroups([]);
    } else {
      this.selectAll();
    }
  };

  updateGroupOrder = () => {
    const { quotables } = this.state;
    const { selectQuoteGroups, visible_quote_group_ids } = this.props;
    selectQuoteGroups(
      quotables
        .filter(q => visible_quote_group_ids.includes(q.quote_group_id))
        .map(q => q.quote_group_id)
    );
  };

  selectQuoteGroup = (quotable, add) => {
    const { quotables } = this.state;
    const { selectQuoteGroups, visible_quote_group_ids } = this.props;
    selectQuoteGroups(
      add
        ? quotables
            .filter(
              q =>
                visible_quote_group_ids.includes(q.quote_group_id) ||
                q.quote_group_id == quotable.quote_group_id
            )
            .map(q => q.quote_group_id)
        : visible_quote_group_ids.filter(id => id !== quotable.quote_group_id)
    );
  };

  renderButtons = () => {
    const { quotables, addingLaboratorySuite, addingNewGroup, isReordering } = this.state;
    return (
      <div
        className="btn-toolbar"
        style={{ marginBottom: 0, justifyContent: "center", display: "flex" }}
      >
        {quotables.length > 0 && (
          <div className="btn-group">
            <Button
              title="Re-order"
              small
              highlight={isReordering}
              onClick={this.toggleReordering}
              icon="fa-sort"
            />
          </div>
        )}
        <div className="btn-group">
          <Button
            small
            title="Laboratory Suites"
            highlight={addingLaboratorySuite}
            onClick={this.toggleAddingLaboratorySuites}
            icon="fa-plus"
          />
        </div>
        <div className="btn-group">
          <Button
            title="Empty Group"
            small
            highlight={addingNewGroup}
            onClick={this.toggleAddingNewGroup}
            icon="fa-plus"
          />
        </div>
        {quotables.length > 0 && (
          <div className="btn-group">
            <Button title="View All" small onClick={this.selectAll} icon="fa-eye" />
          </div>
        )}
      </div>
    );
  };

  renderGroupSorter() {
    const { quotables, isReordering } = this.state;
    const { attempt_id } = this.props;
    if (!isReordering || quotables.length == 0) return null;
    return (
      <div style={{ marginLeft: 30 }}>
        <div style={{ marginBottom: 20 }}>
          <Button
            title="Save Positions"
            onClick={this.savePositions}
            primary
            tiny
            icon={"fa-save"}
          />{" "}
          &nbsp;
          <Button
            title="Sort Alphabetically"
            onClick={() => this.sorter.sortAlphabetically()}
            tiny
          />{" "}
          &nbsp;
          <Button title="Cancel" onClick={this.toggleReordering} tiny />
        </div>
        <QuotableSorter
          key={attempt_id}
          attempt_id={attempt_id}
          quotables={quotables}
          ref={instance => {
            this.sorter = instance;
          }}
        />
      </div>
    );
  }

  render() {
    const {
      loading,
      quotables,
      addingLaboratorySuite,
      addingNewGroup,
      isReordering,
      lastMatrixOption
    } = this.state;
    const { attempt_id, selectQuoteGroups, visible_quote_group_ids } = this.props;
    return (
      <React.Fragment>
        {this.renderButtons()}
        <div className="">
          <div className="" style={{ padding: "5%", paddingTop: 20, paddingBottom: 10 }}>
            {this.renderGroupSorter()}
            {addingLaboratorySuite && (
              <LaboratorySuiteSearcher
                attempt_id={attempt_id}
                onSuitesAdded={this.onGroupsAdded}
                onCancel={this.toggleAddingLaboratorySuites}
              />
            )}
            {addingNewGroup && (
              <NewQuoteGroup
                initialMatrixOption={lastMatrixOption}
                attempt_id={attempt_id}
                onGroupAdded={this.onGroupsAdded}
                onCancel={this.toggleAddingNewGroup}
              />
            )}
            {!isReordering && !loading && (
              <div>
                <table className="table table-condensed toc">
                  <thead>
                    <tr>
                      <th style={{ width: 30 }}>
                        {quotables.length > 1 && (
                          <input
                            type="checkbox"
                            checked={this.willUnSelectAll()}
                            onChange={this.toggleSelectAll}
                          />
                        )}
                      </th>
                      <th>Group Name</th>
                      <th>Matrix</th>
                    </tr>
                  </thead>
                  <tbody>
                    {quotables.map(quotable => (
                      <tr key={quotable.quote_group_id}>
                        <td>
                          <input
                            type="checkbox"
                            onChange={event =>
                              this.selectQuoteGroup(quotable, event.target.checked)
                            }
                            checked={visible_quote_group_ids.includes(quotable.quote_group_id)}
                          />
                        </td>
                        <td>
                          <Link
                            onClick={() => selectQuoteGroups([quotable.quote_group_id])}
                            key={quotable.quote_item_id}
                          >
                            {quotable.name}
                          </Link>
                        </td>
                        <td>
                          <span onClick={() => this.selectByMatrix(quotable.matrix_id)}>
                            {quotable.matrix_name}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
